// extracted by mini-css-extract-plugin
export default {"expandedRow":"CommissionRatesTab_expandedRow__WPhto","clickableRow":"CommissionRatesTab_clickableRow__fdOqI"};